import { css, SerializedStyles } from '@emotion/react';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { ChatState, WebrtcState } from 'sdk';

import { useSDK } from '../../../../app';
import { styled } from '../../../../styled';
import { Theme } from '../../../../theme/interface/detailed';
import { msgs } from './msgs';
import { ScreenShareIcon } from './screenShareIcon';
import { SendToEmailIcon } from './sendToEmailIcon';

const styles = ({
	theme: {
		chat: {
			header: {
				select: { option },
			},
		},
	},
}: {
	theme: Theme;
}): SerializedStyles => css`
	background: #fff;
	border-radius: 4px;
	box-shadow: 0 2px 6px rgba(34, 43, 85, 0.06), 0 10px 16px rgba(52, 53, 70, 0.06);
	cursor: pointer;
	position: absolute;
	right: 0;
	top: 100%;
	width: 300px;
	z-index: 100050;

	& > .option {
		align-items: center;
		background-color: ${option.backgroundColor};
		color: ${option.color};
		display: flex;
		font-size: ${option.fontSize};
		font-weight: ${option.fontWeight};
		line-height: ${option.lineHeight};
		padding: ${option.padding};

		&:hover {
			background-color: ${option.hoverBackgroundColor};
		}

		& > .icon {
			padding-right: 9px;
		}
	}
`;

export const HeaderSelect = styled(
	({
		className,
		showCobrowsingOption,
		showSendToEmailOption,
	}: {
		className: string;
		showCobrowsingOption: boolean;
		showSendToEmailOption: boolean;
	}): ReactElement => {
		const { screenCaptureStore, uiStateStore } = useSDK();
		const { formatMessage } = useIntl();
		const cobrowsingStarted = !(screenCaptureStore.state === WebrtcState.off);
		return (
			<div className={className}>
				{showCobrowsingOption && (
					<div
						className={'option' + (cobrowsingStarted ? ' option_disabled' : '')}
						onClick={!cobrowsingStarted ? screenCaptureStore.createOffer : screenCaptureStore.reject}
					>
						<ScreenShareIcon className="icon" />
						<span>
							{formatMessage(cobrowsingStarted ? msgs.stopScreenSharing : msgs.startScreenSharing)}
						</span>
					</div>
				)}
				{showSendToEmailOption && (
					<div
						className="option"
						onClick={(): void => uiStateStore.setChatState(ChatState.sendDialogToEmail)}
					>
						<SendToEmailIcon className="icon" />
						<span>{formatMessage(msgs.sendHistoryToEmail)}</span>
					</div>
				)}
			</div>
		);
	}
)(styles);
